// Frozen empty defaults — a fresh `[]`/`{}` per render is a new identity (golden rule 8).
export const EMPTY_LIST = Object.freeze([]);
export const EMPTY_MAP = Object.freeze({});
